import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=703b7dac&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('703b7dac')) {
      api.createRecord('703b7dac', component.options)
    } else {
      api.reload('703b7dac', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=703b7dac&", function () {
      api.rerender('703b7dac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26jlLO5SEQX33/JS/pricehelp.vue"
export default component.exports